const en = {
  add_user_agreement:
    "I understand that adding user licenses might result in additional charges, depending on the terms outlined in my contract.",
  "custom.auth.cta_href": "https://pimcore.com/en/platform/paas",
  "custom.auth.cta_text": "Read more",
  "custom.auth.description": " ",
  "custom.auth.hero_text": " ",
  "externalInvitation.powered": "Powered by Upsun",
  "externalInvitation.redirection":
    "This Pimcore PaaS infrastructure feature is powered by Upsun, you are now being redirected to Upsun documentation.",
  "externalInvitation.support.text": "For technical support, please ",
  "footer.message": "Version {appVersion} - Pimcore",
  "links.CLI_download": "https://cli.pimcore.cloud/installer",
  no_credit_card_signup: "Register for free",
  "setup.cli.install.code":
    "curl -sfS https://cli.pimcore.cloud/installer | php",
  "setup.cli.install.label": "Install CLI",
  try_us_for_free: "Create your account",
  "url.logo_url": "https://pimcore.com/en"
};

export default en;
